import React from "react";
import { connect } from "react-redux"
import {
  isInterferometricStackSearchResultElement,
  isProductImageSearchResultElement
} from "../../../helpers/searchResultsHelper";
import {getSearchResultDetailsPropertiesColumns} from "../../../helpers/productHelper";
import QuicklookPreview from "../../shared/QuicklookPreview";
import {ConfigurationsType} from "../../../types/configurations";
import {InterferometricStackType, SearchResultElementType} from "../../../types/product";
import InterferometricStackItemsList from "./shared/InterferometricStackItemsList";

interface PropsType {
  configurations: ConfigurationsType,
  searchResultDetails: SearchResultElementType,
  language: string
}

const BodySearchResultDetailsSidebar = (props: PropsType) => {
  const {
    configurations,
    searchResultDetails,
      language
  } = props;

  return (
    <>
      <div className="search-result-details-body" style={isInterferometricStackSearchResultElement(searchResultDetails) ? {overflow: 'auto', maxHeight: '60vh', height: 'calc(60vh - 180px)'} : {}}>
        {
          isProductImageSearchResultElement(searchResultDetails) && (
            <div className="quicklook-preview-container">
              <QuicklookPreview
                productImage={{...searchResultDetails}}
              />
            </div>
          )
        }
        <div>
          {getSearchResultDetailsPropertiesColumns(configurations, searchResultDetails, language).map(({label, value, textValue}) => (
            <p
              key={`body-search-result-details-sidebar-label-${label}`}
              data-label={label}
              className="single-detail"
            >
              <span className="description">{label}</span>
              <span className="value" title={value}>{textValue}</span>
            </p>
          ))}
        </div>
      </div>
      {
        isInterferometricStackSearchResultElement(searchResultDetails) && (
          <InterferometricStackItemsList
            interferometricStack={searchResultDetails as InterferometricStackType}
          />
        )
      }
    </>
  )
};

const mapStateToProps = (state) => ({
  language: state.application.appParameters.language
});

export default connect(mapStateToProps)(BodySearchResultDetailsSidebar)
